/**
 * Acceso al módulo legacy Munily Pay (`/app/munily-pay/*`).
 * Debe mantenerse alineado con {@link SuperAdminMunilyPayRol} y {@link SuperAdminRol}
 * en `pages.routing.ts` (ruta padre `munily-pay`).
 */
export const MUNILY_PAY_AUTHORIZED_EMAILS: readonly string[] = [
  'mitchell@munily.com',
  'ycamargo@munily.com',
];

export interface MunilyPayMenuAccessUser {
  email?: string;
  roles?: string[];
}

/** Usuario autorizado a ver/navegar Munily Pay (superAdmin + email en lista). */
export function canShowMunilyPayTransactionsMenu(user: MunilyPayMenuAccessUser | null | undefined): boolean {
  if (!user?.email || !user.roles?.length) {
    return false;
  }
  if (user.roles.indexOf('superAdmin') === -1) {
    return false;
  }
  return MUNILY_PAY_AUTHORIZED_EMAILS.includes(user.email);
}

/** Ítem de menú Munily Pay: fintech del PH activo y usuario con acceso real a la ruta. */
export function shouldShowMunilyPayTransactionsMenu(
  user: MunilyPayMenuAccessUser | null | undefined,
  fintechConfig: { enable?: boolean } | null | undefined,
): boolean {
  return !!(fintechConfig?.enable && canShowMunilyPayTransactionsMenu(user));
}
